import { render } from "./Pulmonology.vue?vue&type=template&id=04cd15ca&scoped=true"
import script from "./Pulmonology.vue?vue&type=script&lang=ts"
export * from "./Pulmonology.vue?vue&type=script&lang=ts"

import "./Pulmonology.vue?vue&type=style&index=0&id=04cd15ca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-04cd15ca"

export default script